import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Send } from "lucide-react";
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
const Contact = () => {
  const navigate = useNavigate();
  const {
    toast
  } = useToast();
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Create mailto link with form data
    const subject = encodeURIComponent("פנייה מתיק העבודות");
    const body = encodeURIComponent(`שם: ${formData.name}\n\nכתובת מייל: ${formData.email}\n\nבכמה מילים, במה אתם מתעניינים:\n${formData.message}`);
    const mailtoLink = `mailto:learning.and.path@gmail.com?subject=${subject}&body=${body}`;

    // Try to open mailto link
    try {
      const link = document.createElement('a');
      link.href = mailtoLink;
      link.target = '_blank';
      link.click();
      toast({
        title: "תודה על פנייתך!",
        description: "תוכנת המייל שלך תיפתח כעת. אם לא, שלח ישירות ל: learning.and.path@gmail.com"
      });
    } catch (error) {
      toast({
        title: "שגיאה",
        description: "אנא שלח מייל ישירות ל: learning.and.path@gmail.com",
        variant: "destructive"
      });
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 rtl">
      {/* Header */}
      <div className="relative overflow-hidden min-h-[40vh] flex items-center">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-100 via-cyan-200 to-teal-200"></div>
          <div className="absolute inset-0 opacity-25">
            <div className="absolute top-20 left-20 w-96 h-96 bg-gradient-to-br from-cyan-200/30 to-transparent rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-20 w-80 h-80 bg-gradient-to-br from-teal-200/25 to-transparent rounded-full blur-3xl"></div>
          </div>
        </div>
        
        <div className="relative container mx-auto px-6 py-20">
          <div className="text-center max-w-4xl mx-auto">
            <Button onClick={() => navigate('/')} className="mb-8 bg-blue-600/80 hover:bg-blue-700/80 text-white border border-blue-500/50 font-medium px-6 py-3 rounded-xl shadow-lg">
              <ArrowRight className="w-4 h-4 mr-2" />
              חזרה לדף הבית
            </Button>
            
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-blue-900 leading-tight mb-6">
              יצירת קשר
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 py-16">
        <Card className="max-w-4xl mx-auto bg-white/80 backdrop-blur-md border border-white/50 shadow-2xl rounded-3xl">
          <CardContent className="p-8">
            <div className="text-right text-lg leading-relaxed text-slate-700 font-rounded" style={{
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}>
              <p className="mb-6">
                אם אחת מהתכניות, המודלים או תהליכי הליווי, מעוררים בכם עניין ותרצו לחשוב יחד על התאמה לארגון, לצוות או לקהילה, אשמח לשיחה קצרה, אישית ובלתי מחייבת.
              </p>
              <p className="mb-8">
                העבודה שלי מתחילה בהקשבה ובבחינה משותפת של הצרכים, ההקשר והאפשרויות.
              </p>

              {/* Button to show form */}
              {!showForm && <div className="flex justify-center mt-8">
                  <button onClick={() => setShowForm(true)} className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                    <Send className="w-5 h-5" />
                    <span className="text-lg">לשיחה והיכרות</span>
                  </button>
                </div>}

              {/* Contact Form - shown after button click */}
              {showForm && <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border-2 border-blue-200 rounded-2xl p-8 mt-8">
                  <h2 className="text-2xl font-bold text-blue-900 mb-6 text-right">לשיחה והיכרות:</h2>
                  
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                      <label htmlFor="name" className="block text-right text-base font-medium text-slate-700 mb-2">
                        שם:
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 text-right border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent" dir="rtl" />
                    </div>

                    <div>
                      <label htmlFor="email" className="block text-right text-base font-medium text-slate-700 mb-2">
                        כתובת מייל:
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 text-right border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent" dir="rtl" />
                    </div>

                    <div>
                      <label htmlFor="message" className="block text-right text-base font-medium text-slate-700 mb-2">
                        בכמה מילים, במה אתם מתעניינים:
                      </label>
                      <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={5} className="w-full px-4 py-3 text-right border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none" dir="rtl" />
                    </div>

                    <div className="flex justify-center">
                      <button type="submit" className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                        <Send className="w-5 h-5" />
                        <span className="text-lg">שלח הודעה</span>
                      </button>
                    </div>
                  </form>
                  
                  {/* Direct Contact Info - Inside Form */}
                  <div className="border-t-2 border-blue-300 mt-8 pt-8">
                    <h3 className="text-xl font-bold text-blue-900 mb-4 text-right">אפשר גם לפנות ישירות:</h3>
                    
                    <div className="space-y-3 text-right">
                      <p className="text-lg font-semibold text-blue-900">רסיטל יצחקי</p>
                      
                      <div className="space-y-2">
                        <p className="text-base text-slate-700">
                          <span className="font-medium">וואטסאפ:</span>{" "}
                          <a href="https://wa.me/972507689544" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">
                            0507689544
                          </a>
                        </p>
                        
                        <p className="text-base text-slate-700">
                          <span className="font-medium">מייל:</span>{" "}
                          <a href="mailto:learning.and.path@gmail.com" className="text-blue-600 hover:text-blue-800 underline">
                            learning.and.path@gmail.com
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
};
export default Contact;